<template>
  <BaseCardList
      :item-list="itemList"
      :common="common"
      :delete-restore-event="onValidate"
      :default-item="newItem"
      :correct-default-item="function() {return true}"
      :enable-add-row="function() {return true}"
      xl="12" lg="12" md="12" sm="12" xs="12"
      :system-bar-height="36"
      :get-card-title-color="getTitleColor"
      :disableDrag="false"
      :disable-item-edit="function(x){return readonly}"
      :show-deleted="showDeleted"
      :tabs="tabsList"
      :new-item-name="$t('new_document')"
  >
    <template v-slot:top>
    </template>
    <template v-slot:bar.number></template>
    <template v-slot:default="params">
      <TipTapEditor v-model="params.item.content">
        <template v-slot:bar.end>
          <v-btn
              v-if="params.item.deleted === false"
              :disabled="readonly"
              icon
              @click="deleteItem(params.item)"
          >
            <v-icon color="red lighten-2">mdi-delete-outline</v-icon>
          </v-btn>
          <v-btn
              v-if="params.item.deleted === true"
              :disabled="readonly"
              icon
              @click="restoreItem(params.item)"
          >
            <v-icon color="red lighten-2">mdi-close-thick</v-icon>
          </v-btn>
        </template>
      </TipTapEditor>
    </template>
  </BaseCardList>
</template>

<script>
import BaseCardList from "@/components/Base/BaseCardList";
import TipTapEditor from "@/components/TipTap/TipTapEditor";

export default {
  name: 'LibraryDocCardList',
  props: {
    height: {type: [Number], default: window.innerHeight},
    systemBarHeight: {type: [Number], default: 36},
    itemList: {factory: []},
    readonly: {type: [Boolean], default: false},
    common: {
      default: () => {
      }
    },

    showDeleted: {type: [Boolean], default: true},
    tabs: {
      type: [Function], default: function (item) {
        return []
      }
    },
    defaultTab: {type: [Number], default: 0},
    defaultTabAfterAdd: {type: [Number], default: 0},
  },

  components: {
    BaseCardList,
    TipTapEditor,
  },

  computed: {},

  watch: {
    itemList: {
      handler(newValue, oldValue) {
        // console.log('watch')
        this.emitValue()
      },
      deep: true
    }
  },

  methods: {
    lockPage(editedItem) {
      return !(!!editedItem && !!editedItem.page_properties && !editedItem.page_properties.lock_page)
    },

    emitValue() {
      // console.log('emitValue')
      this.$emit('update:itemList', this.itemList)
    },

    tabsList(item) {
      return []
      // return [this.$t('tabs.description'), this.$t('tabs.machine'), this.$t('tabs.parameters')]
    },

    onValidate() {

    },
    getTitleColor({item, index}) {
      return 'grey lighten-2'
    },
    deleteItem(item) {
      if (item.hasOwnProperty('id') && item.id != null)
        item.deleted = true
      else {
        let index = this.itemList.indexOf(item)
        this.itemList.splice(index, 1)
      }
      this.emitValue()
      this.deleteRestoreEvent()
    },

    restoreItem(item) {
      item.deleted = false
      this.emitValue()
      this.deleteRestoreEvent()
    },
  },

  async mounted() {
  }
  ,

  data() {
    return {
      newItem: {
        name: null,
        deleted: false,
        description: null,
      },
      html: '<h1>Hello There</h1>\n' +
          '<p>Resizable image:</p>\n' +
          '<img src="https://source.unsplash.com/8xznAGy4HcY/800x400" width="240" height="120" />' +
          '<img src="/store/file/18991" width="240" height="120" />' +
          '<img src="/store/file/18959" width="240" height="120" />' +
          '<video src="https://www.youtube.com/embed/Nyx6SBixRE8"></video>' +
          '<video src="https://player.vimeo.com/video/377282759?h=bb770496b4"></video>' +
          '</p>',
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "new_document": "New document"
  },
  "de": {
    "new_document": "Neues Dokument"
  }
}
</i18n>
